module.exports = __webpack_public_path__ + "static/Rheingau2-scaled-77dd66889311c32d67a59695f829e41c.jpeg";